import { render, staticRenderFns } from "./register-verify.vue?vue&type=template&id=751e9068&scoped=true"
import script from "./register-verify.vue?vue&type=script&lang=js"
export * from "./register-verify.vue?vue&type=script&lang=js"
import style0 from "./register-verify.vue?vue&type=style&index=0&id=751e9068&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751e9068",
  null
  
)

export default component.exports